import axios from "axios";
import { setStorePages, setStorePagesError, setStorePagesLoading } from "src/store/slices/storePages-slice";
import { store } from "src/store/store";
import { getShopId } from "src/api/axiosInstance";

/**
 * Fetches store pages from the CMS API
 * @returns {Promise<Array>} - Array of store pages
 */
export const fetchStorePages = async () => {
  store.dispatch(setStorePagesLoading());
  try {
    const shopId = getShopId();
    
    if (!shopId) {
      throw new Error("Shop ID is not available");
    }

    const response = await axios.get(
      `https://cms.blinkz.in/items/store_pages?filter[store_id][_eq]=${shopId}&fields=*,Image.*&filter[status]=published`
    );
    
    // Sort by sort_order if available
    const sortedPages = response.data?.data ? 
      response.data.data.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)) : 
      [];
    
    store.dispatch(setStorePages(sortedPages));
    return sortedPages;
  } catch (error) {
    console.error("Error fetching store pages:", error);
    store.dispatch(setStorePagesError(error.message || "Failed to fetch store pages"));
    return [];
  }
};

/**
 * Fetches a single store page by slug
 * @param {string} slug - The slug of the store page
 * @returns {Promise<Object|null>} - Store page object or null if not found
 */
export const fetchStorePageBySlug = async (slug) => {
  try {
    const shopId = getShopId();
    
    if (!shopId) {
      throw new Error("Shop ID is not available");
    }

    if (!slug) {
      throw new Error("Slug is required");
    }

    const response = await axios.get(
      `https://cms.blinkz.in/items/store_pages?filter[store_id][_eq]=${shopId}&filter[slug][_eq]=${slug}&fields=*,Image.*&filter[status]=published`
    );
    
    const page = response.data?.data?.[0] || null;
    
    if (!page) {
      throw new Error("Store page not found");
    }
    
    return page;
  } catch (error) {
    console.error("Error fetching store page by slug:", error);
    throw error;
  }
};